<template>
  <a-form class="contacts-form" :form="form" @submit.prevent="handleSubmit">
    <r-title>{{ $t('contacts.form.title') }}</r-title>
    <a-form-item>
      <a-input
        :placeholder="$t('full.name')"
        @change="handleChange"
        name="fullName"
        v-decorator="[
          'fullName',
          {
            initialValue: fullName,
            rules: [
              {
                required: true,
                message: $t('validation.required'),
              },
            ],
          },
        ]"
      />
    </a-form-item>
    <email-input v-model="email" />
    <a-form-item>
      <a-textarea :placeholder="$t('message')" :autoSize="autosize" v-model="message" />
    </a-form-item>
    <a-button
      type="primary"
      html-type="submit"
      :loading="loading"
      :disabled="disabled"
    >{{ $t('send') }}</a-button>
  </a-form>
</template>

<script>
import firebase from 'firebase/app';
import { mapActions, mapGetters } from 'vuex';
import { SHOW_NOTIFICATION } from '@/store/notification/actionTypes';
import sendSupportEmail from '@/services/network/contacts';
import RTitle from '@/components/common/Title.vue';
import EmailInput from '@/components/common/EmailInput.vue';

export default {
  components: {
    RTitle,
    EmailInput,
  },
  data() {
    return {
      fullName: '',
      email: '',
      loading: false,
      message: '',
      autosize: {
        minRows: 5,
        maxRows: 5,
      },
      disabled: true,
      user: firebase.auth().currentUser,
    };
  },
  computed: {
    ...mapGetters(['privateInfo']),
    userFullName() {
      return `${this.privateInfo.firstName} ${this.privateInfo.lastName}`;
    },
    userEmail() {
      return this.privateInfo.email;
    },
  },
  watch: {
    userFullName() {
      if (this.user) {
        this.fullName = this.userFullName;
      }
    },
    userEmail() {
      if (this.user) {
        this.email = this.userEmail;
      }
    },
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'contacts' });
  },
  provide() {
    return {
      form: this.form,
    };
  },
  methods: {
    ...mapActions({
      showNotification: SHOW_NOTIFICATION,
    }),
    async handleSubmit() {
      const data = {
        fullName: this.fullName,
        email: this.email,
        message: this.message,
        userStatus: this.userStatus(),
      };

      this.loading = true;

      try {
        await sendSupportEmail(data);
        this.showNotification({
          type: 'success',
          message: this.$t('submit.contacts.success'),
        });
        this.message = '';
      } catch (err) {
        this.showNotification({
          type: 'error',
          message: this.$t('submit.contacts.error'),
        });
      } finally {
        this.loading = false;
      }
    },
    handleChange(e) {
      this[e.target.name] = e.target.value;
    },
    updateDisabled() {
      this.form.validateFields((err) => {
        if (!err && this.message) {
          this.disabled = false;
        } else {
          this.disabled = true;
        }
      });
    },
    userStatus() {
      return this.user ? 'Logged in user' : 'Not logged in user';
    },
  },
  created() {
    if (this.user) {
      this.fullName = this.userFullName;
      this.email = this.userEmail;
    }
  },
  updated() {
    this.updateDisabled();
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/variables';
@import '~@/assets/styles/colors';
@import '~@/assets/styles/breakpoints';

.contacts-form {
  width: 440px;
  padding: 40px;
  margin: 0 15px;
  border-radius: $border-radius;
  box-shadow: 0 0 8px 0 rgba(17, 25, 53, 0.16);
  color: $dark-grey;
}

@media (max-width: $login-base-breakpoint) {
  .contacts-form {
    width: 100%;
    padding: 10px 20px;
  }
}
</style>
